'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'pen-nib';
var width = 512;
var height = 512;
var aliases = [10001];
var unicode = 'f5ad';
var svgPathData = 'M374.1 198.1s0 0 0 0l-3.6 10.7L314.2 377.6 84.5 450.1 187.3 347.3c6.3 3 13.3 4.7 20.7 4.7c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48c0 7.4 1.7 14.4 4.7 20.7L61.9 427.5l72.5-229.7 168.8-56.3 10.7-3.6s0 0 0 0l60.1 60.1zM48 512l304-96 64-192 62.1-62.1L512 128 478.1 94.1 417.9 33.9 384 0 350.1 33.9 288 96 96 160 0 464l48 48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPenNib = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;